import React, { useMemo, useState } from "react"
import { Modal, ModalBody, ModalHeader, UncontrolledTooltip } from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import { Link } from "react-router-dom"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
import { usePermission } from "hooks/usePermission"
import { PERMISSIONS } from "helpers/roles"
import { getTableSortingHeaderIcon, handleDownload } from "helpers/common"
import downloadIcon from "../assets/images/downloadGrey.svg"
import eye from "../assets/images/icons/eye.svg"

const SchedulesModel = ({ data, close, open, checkPermission = true }) => {
  const { hasPermission } = usePermission()

  const columns = useMemo(() => {
    const data = [
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Investor Detail"),
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <DefaultAvatar
            avatar_url={row?.original.investor.avatar_url}
            email={row?.original.investor.email}
            name={row?.original.investor.name}
          />
        ),
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "ICD Request ID"),
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-number">
            {row?.original.icdsRequests?.unique_code}
          </div>
        ),
      },
      {
        header: "Reference No.",
        accessorKey: "referenceNo",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>{row?.original.agreement_ref || "Not Applicable"}</>
        ),
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Signing Type"),
        accessorKey: "doc_type",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-status">
            <div className="badge approved">
              <span></span> ICD Schedule Terms
            </div>
          </div>
        ),
      },
      {
        header: "Audit Trail",
        id: "audit_trail",
        cell: ({ row }) => {
          const viewAuditTooltip = `viewAuditTooltip-${row?.original?.id}`
          return (
            <div className="d-flex justify-content-center align-items-center flex-row gap-2">
              {/* <a href={row.original.doc}>Sign Now</a> */}
              <div className="action-view">
                <Link
                  to={row.original.audit_doc_url}
                  target="_blank"
                  id={viewAuditTooltip}
                >
                  <img src={eye} alt="" />
                  <UncontrolledTooltip
                    placement="top"
                    target={viewAuditTooltip}
                  >
                    View Audit Trail
                  </UncontrolledTooltip>
                </Link>
              </div>
            </div>
          )
        },
      },
      {
        id: "actions",
        header: "Actions",

        cell: ({ row }) => {
          const viewTooltip = `viewTooltip-${row?.original?.id}`
          const downloadTooltip = `downloadTooltip-${row?.original?.id}`
          return (
            <div className="d-flex justify-content-center align-items-center flex-row gap-2">
              {/* <a href={row.original.doc}>Sign Now</a> */}
              <div className="action-view">
                <Link
                  to={row.original.doc_url}
                  target="_blank"
                  id={viewTooltip}
                >
                  <img src={eye} alt="" />
                  <UncontrolledTooltip placement="top" target={viewTooltip}>
                    View
                  </UncontrolledTooltip>
                </Link>
              </div>
              <div className="action-view">
                <Link
                  to={"#"}
                  id={downloadTooltip}
                  onClick={() =>
                    handleDownload(
                      row.original.doc_url,
                      row?.original.icdsRequests?.unique_code
                    )
                  }
                >
                  <img src={downloadIcon} alt="" />
                  <UncontrolledTooltip placement="top" target={downloadTooltip}>
                    Download
                  </UncontrolledTooltip>
                </Link>
              </div>
            </div>
          )
        },
      },
    ]

    const canAccess = !checkPermission
      ? true
      : hasPermission(PERMISSIONS.ICD_VIEW)

    const result = canAccess
      ? data
      : data.filter((item) => item.id !== "actions")

    return result
  }, [hasPermission, checkPermission])

  return (
    <Modal
      isOpen={open}
      toggle={() => {
        close()
      }}
      size="lg"
      centered={true}
    >
      <ModalHeader
        toggle={() => {
          close()
        }}
      >
        Schedules
      </ModalHeader>
      <ModalBody>
        <TableContainer
          filters={{
            page: 1,
            pageSize: 100,
          }}
          columns={columns}
          data={data}
          isPagination={false}
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </ModalBody>
    </Modal>
  )
}

export default SchedulesModel
